// Orders related store state and actions.

import axiosApiClient from '@/api/axiosApiClient'
import log from '@/utils/log'


// State
export const state = {
	list: [],
	loading: false,
	error: null,
}

// Getters
export const getters = {}

// Mutations
export const mutations = {
	UPDATE_ORDER_REQUEST(state) {
		state.loading = true
		state.error = null
	},
	UPDATE_ORDER_SUCCESS(state, updatedOrder) {
		state.loading = false
		state.error = null

		const originalOrderIndex = state.list.findIndex((o) => o.id === updatedOrder.id)
		if (originalOrderIndex !== -1) {
			state.list[originalOrderIndex] = updatedOrder
		}
	},
	UPDATE_ORDER_FAILURE(state, error) {
		state.loading = false
		state.error = error
	},
	FETCH_ORDER_REQUEST(state) {
		state.loading = true
		state.error = null
	},
	FETCH_ORDER_SUCCESS(state, list) {
		state.loading = false
		state.error = null
		state.list = list
	},
	FETCH_ORDER_FAILURE(state, error) {
		state.loading = false
		state.error = error
	},
	RESET_ORDER(state) {
		state.loading = false
		state.error = null
		state.list = []
	}
}

// Actions
export const actions = {
	// Fetches orders list.
	async fetchOrders({ commit, dispatch, rootState }) {
		const { clientId } = rootState.auth.currentUser

		commit('FETCH_ORDER_REQUEST')
		try {
			const params = {
				limit: 100,
				...(clientId && { clientId }),
			}

			const { data } = await axiosApiClient.get(`/orders`, { params })
			commit('FETCH_ORDER_SUCCESS', data)
		} catch (error) {
			commit('FETCH_ORDER_FAILURE', error)
			log.error('Failed to fetch orders', { category: 'API' }, error.stack)
		}
	},

	async updateOrder({ commit , dispatch, rootState }, { orderId, payload }) {
		commit('UPDATE_ORDER_REQUEST')
		try {
			const { data } = await axiosApiClient.patch(`/orders/${orderId}`, payload)
			commit('UPDATE_ORDER_SUCCESS', data)
		} catch (error) {
			commit('UPDATE_ORDER_FAILURE', error)
			log.error('Failed to update order', { category: 'API' }, error.stack)
		}
	},

	resetOrders({ commit }) {
		commit('RESET_ORDER')
	},
}
